<mat-form-field appearance="outline">
  <mat-label>{{ label }}</mat-label>

  <mat-select [formControl]="control">
    <mat-option *ngFor="let option of options" [value]="option.value">
      {{ option.key }}
    </mat-option>
  </mat-select>
</mat-form-field>
